var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: {
        title: _vm.titleDialog,
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "50%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onHandleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "contents" },
        [
          _c(
            "el-form",
            {
              ref: "refForm",
              attrs: {
                model: _vm.formData,
                "label-width": "150px",
                rules: _vm.formRules,
                loading: _vm.formLoading,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "扣款类型：", prop: "deduction_type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择扣款类型",
                        disabled: _vm.disabledData,
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.deduction_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "deduction_type", $$v)
                        },
                        expression: "formData.deduction_type",
                      },
                    },
                    _vm._l(_vm.deductionTypeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商：", prop: "supplier_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        loading: _vm.loadingSupplierList,
                        disabled: _vm.disabledData,
                        filterable: "",
                        clearable: "",
                        placeholder: "选择供应商",
                      },
                      model: {
                        value: _vm.formData.supplier_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "supplier_id", $$v)
                        },
                        expression: "formData.supplier_id",
                      },
                    },
                    _vm._l(_vm.supplierList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: `${item.title}【${item.mobile}】`,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.formData.deduction_type == 150
                ? _c(
                    "el-form-item",
                    { attrs: { label: "订单编号：", prop: "order_no" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.disabledData,
                          placeholder: "输入订单编号",
                          clearable: "",
                        },
                        on: { blur: _vm.goodsblur },
                        model: {
                          value: _vm.formData.order_no,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "order_no", $$v)
                          },
                          expression: "formData.order_no",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.deduction_type == 150
                ? _c(
                    "el-form-item",
                    { attrs: { label: "商品名称：", prop: "sku_code" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "选择商品名称",
                            disabled: _vm.disabledData,
                            clearable: "",
                          },
                          on: { change: _vm.sku_change },
                          model: {
                            value: _vm.formData.sku_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "sku_code", $$v)
                            },
                            expression: "formData.sku_code",
                          },
                        },
                        _vm._l(_vm.goodsList, function (item) {
                          return _c("el-option", {
                            key: item.sku_code,
                            attrs: { label: item.title, value: item.sku_code },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleOptionClick(item)
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.deduction_type == 150 && _vm.goodsinfo
                ? _c("div", { staticClass: "tooltip" }, [
                    _vm._v(
                      " 订单总金额：" +
                        _vm._s(_vm.goodsinfo.order_amt) +
                        "元，该商品总金额：" +
                        _vm._s(_vm.goodsinfo.sku_code_amt) +
                        " 元；该商品 已申请售后退款 " +
                        _vm._s(_vm.goodsinfo.refund_amt) +
                        " 元，剩余可退金额 " +
                        _vm._s(_vm.goodsinfo.remain_amt) +
                        "元； "
                    ),
                  ])
                : _vm._e(),
              _vm.requiredAsNo
                ? _c(
                    "el-form-item",
                    { attrs: { label: "售后单号：", prop: "as_no" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.disabledData,
                          placeholder: "输入售后单号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.formData.as_no,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "as_no", $$v)
                          },
                          expression: "formData.as_no",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.deduction_type == 150
                ? _c("p", { staticClass: "tooltip" }, [
                    _vm._v(
                      " 扣款类型为投诉扣款且关联订单号后将给用户线上退款，请谨慎操作 "
                    ),
                  ])
                : _vm._e(),
              _vm.formData.deduction_type == 80
                ? _c("p", { staticClass: "tooltip" }, [
                    _vm._v(
                      " 扣款类型为二次售后扣款且关联售后单号后将给用户线上退款，请谨慎操作 "
                    ),
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "金额：", prop: "deduction_amt" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.disabledData,
                      placeholder: "输入金额",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formData.deduction_amt,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "deduction_amt", $$v)
                      },
                      expression: "formData.deduction_amt",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remarks" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "输入备注",
                      maxlength: "200",
                      disabled: _vm.disabledData,
                      rows: 3,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "remarks", $$v)
                      },
                      expression: "formData.remarks",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "相关证明：", prop: "pic" } },
                [
                  _c("b-file-upload", {
                    attrs: {
                      accepts: ["jpg", "jpeg", "png"],
                      limit: 5,
                      disabled: _vm.disabledData,
                    },
                    model: {
                      value: _vm.picList,
                      callback: function ($$v) {
                        _vm.picList = $$v
                      },
                      expression: "picList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传视频：" } },
                [
                  _c("b-file-upload", {
                    attrs: {
                      accepts: ["mp4", "avi", "flv", "mov"],
                      limit: 1,
                      disabled: _vm.disabledData,
                    },
                    model: {
                      value: _vm.videoList,
                      callback: function ($$v) {
                        _vm.videoList = $$v
                      },
                      expression: "videoList",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          !_vm.disabledData
            ? _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取消"),
              ])
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.disabledSubmit },
              on: { click: _vm.onHandleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }